export default "__VITE_ASSET__v4vT4DEB__"